import api from '../../api'
import {INITIALIZE, CLEAR_STATE} from '../mutations/available';

export const initApplication = async ({commit, dispatch}) => {
  try {
    let initialData = await api.getInitialData()
    commit(INITIALIZE, initialData)

    dispatch('afterApplicationInit', initialData)
  } catch (e) {
    console.log(e)
  }
}

export const afterLogout = async ({commit}) => {
  commit(CLEAR_STATE)
}